// "New"-communicatie rond multi-build sets (gelanceerd eind juli 2026).
// Zelfde patroon als sortModeLaunch: na de vervaldatum verdwijnt de
// New-badge vanzelf - eeuwige "New"-badges devalueren.
export const MULTI_BUILD_NEW_UNTIL = '2026-09-01';

// Aangezet 28 juli 2026 na afronding van de backfill-sweep (~110 sets met
// gecontroleerde namen). Uitzetten kan altijd door deze op false te zetten.
export const MULTI_BUILD_PROMO_ENABLED = true;

export function isMultiBuildNew() {
  return new Date() < new Date(MULTI_BUILD_NEW_UNTIL);
}
